import type { Drip, DripStatus } from '@bt-common/schemas/bt/drip';
import type { Campaign, CampaignStatus } from '@common-models/campaign-model';

const isDoneCampaign = (cs?: CampaignStatus): boolean =>
  cs === 'complete-sent' || cs === 'completed' || cs === 'complete-delivered';

/** THE single source of truth for a drip's displayed status. A drip whose EVERY
 *  step has a completed campaign is 'completed' even if the stored status lags
 *  (last step finished while paused, a race, test poking). `draft`/`aborted`
 *  are terminal and returned as-is. `stepCampaigns` = the drip's step campaigns
 *  (dripStepIndex-tagged). */
export function deriveDripStatus(
  drip: Pick<Drip, 'status' | 'steps'> | undefined,
  stepCampaigns: Campaign[],
): DripStatus {
  const stored = (drip?.status ?? 'draft') as DripStatus;
  if (stored === 'draft' || stored === 'aborted') return stored;
  const steps = drip?.steps ?? [];
  if (steps.length === 0) return stored;
  const allDone = steps.every((s) =>
    stepCampaigns.some((c) => c.dripStepIndex === s.stepIndex && isDoneCampaign(c.campaignStatus)),
  );
  return allDone ? 'completed' : stored;
}
